import { get } from "@ember/object"
import Component from "@glimmer/component"
import type { CardStack } from "@shared/models/card-stack"
import type { Planbook } from "@shared/models/planbook"
import { sortBy } from "lodash-es"

interface Signature {
  Args: {
    cardStack: CardStack
    planbook: Planbook
    hideTemplateMagic: boolean
    /** When provided, shows the "Delete Template" option that calls this on click. */
    onDelete?: () => void
  }
}

export default class LegacyLessonTemplate extends Component<Signature> {
  get sortedCards() {
    return sortBy(get(this.args.cardStack.attributes, "cards"), (card) =>
      get(card.attributes, "position")
    )
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "School::Edit::LegacyLessonTemplate": typeof LegacyLessonTemplate
  }
}
